import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IUserReference } from 'user/user-reference';

@Component({
	selector: 'spr-coach-profile-diplomas',
	templateUrl: './coach-profile-diplomas.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachProfileDiplomasComponent {
	@Input() public diplomas: IUserReference[];

	constructor() {}
}
